export default __webpack_public_path__ + "static/media/testimonial-pic.22457d40.jpeg";